import { updateRequirementDefinition } from "../../../services/requirementDefinitions/updateRequirementDefinition";
import { useWSMutation } from "../../helpers";
import {
  QUERY_REQUIREMENT_DEFINITION,
  QUERY_REQUIREMENT_DEFINITIONS_LIST,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
} from "../keys";
import { queriesPayeeRows } from "@query";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/useQueryPayeeRowsSummary";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/useQueryPayeeRows";
import { REQUIREMENTS_DEPENDENCIES } from "../../../modules/Requirements/dependencies";

export const useMutationUpdateRequirementDefinition = (id: string) =>
  useWSMutation(
    (payload: Parameters<typeof updateRequirementDefinition>[1]) =>
      updateRequirementDefinition(id, payload),
    {
      dependencies: [
        [QUERY_REQUIREMENT_DEFINITION, id],
        QUERY_REQUIREMENT_DEFINITIONS_LIST,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE,
        QUERY_PAYEE_ROWS_SUMMARY,
        QUERY_PAYEE_ROWS,
        queriesPayeeRows.searchPayeeRows.queryKeyBase,
        ...REQUIREMENTS_DEPENDENCIES
      ]
    }
  );
